export default __webpack_public_path__ + "static/media/i045vk.e4bf54b0.webp";